module.exports = __webpack_public_path__ + "assets/certificate_pdf/2021_CySecSpecialist_Components.539db041.pdf";